// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebsitesRouteImport } from './routes/websites'
import { Route as TheProblemRouteImport } from './routes/the-problem'
import { Route as TestimonialArchiveRouteImport } from './routes/testimonial-archive'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SiteSpeedRouteImport } from './routes/site-speed'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PaidAdsRouteImport } from './routes/paid-ads'
import { Route as MaingearCaseStudyRouteImport } from './routes/maingear-case-study'
import { Route as Homepage_test_2RouteImport } from './routes/homepage_test_2'
import { Route as Homepage_testRouteImport } from './routes/homepage_test'
import { Route as HomepageArchiveOriginalRouteImport } from './routes/homepage-archive-original'
import { Route as HomePageArchiveRouteImport } from './routes/home-page-archive'
import { Route as GetMockupRouteImport } from './routes/get-mockup'
import { Route as DesignSubscriptionRouteImport } from './routes/design-subscription'
import { Route as CarePlansRouteImport } from './routes/care-plans'
import { Route as BrandingRouteImport } from './routes/branding'
import { Route as AiServicesRouteImport } from './routes/ai-services'
import { Route as R1On1WebsiteHelpRouteImport } from './routes/1-on-1-website-help'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as WorkSlugRouteImport } from './routes/work.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const WebsitesRoute = WebsitesRouteImport.update({
            id: '/websites',path: '/websites',getParentRoute: () => rootRouteImport
          })
const TheProblemRoute = TheProblemRouteImport.update({
            id: '/the-problem',path: '/the-problem',getParentRoute: () => rootRouteImport
          })
const TestimonialArchiveRoute = TestimonialArchiveRouteImport.update({
            id: '/testimonial-archive',path: '/testimonial-archive',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SiteSpeedRoute = SiteSpeedRouteImport.update({
            id: '/site-speed',path: '/site-speed',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PaidAdsRoute = PaidAdsRouteImport.update({
            id: '/paid-ads',path: '/paid-ads',getParentRoute: () => rootRouteImport
          })
const MaingearCaseStudyRoute = MaingearCaseStudyRouteImport.update({
            id: '/maingear-case-study',path: '/maingear-case-study',getParentRoute: () => rootRouteImport
          })
const Homepage_test_2Route = Homepage_test_2RouteImport.update({
            id: '/homepage_test_2',path: '/homepage_test_2',getParentRoute: () => rootRouteImport
          })
const Homepage_testRoute = Homepage_testRouteImport.update({
            id: '/homepage_test',path: '/homepage_test',getParentRoute: () => rootRouteImport
          })
const HomepageArchiveOriginalRoute = HomepageArchiveOriginalRouteImport.update({
            id: '/homepage-archive-original',path: '/homepage-archive-original',getParentRoute: () => rootRouteImport
          })
const HomePageArchiveRoute = HomePageArchiveRouteImport.update({
            id: '/home-page-archive',path: '/home-page-archive',getParentRoute: () => rootRouteImport
          })
const GetMockupRoute = GetMockupRouteImport.update({
            id: '/get-mockup',path: '/get-mockup',getParentRoute: () => rootRouteImport
          })
const DesignSubscriptionRoute = DesignSubscriptionRouteImport.update({
            id: '/design-subscription',path: '/design-subscription',getParentRoute: () => rootRouteImport
          })
const CarePlansRoute = CarePlansRouteImport.update({
            id: '/care-plans',path: '/care-plans',getParentRoute: () => rootRouteImport
          })
const BrandingRoute = BrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => rootRouteImport
          })
const AiServicesRoute = AiServicesRouteImport.update({
            id: '/ai-services',path: '/ai-services',getParentRoute: () => rootRouteImport
          })
const R1On1WebsiteHelpRoute = R1On1WebsiteHelpRouteImport.update({
            id: '/1-on-1-website-help',path: '/1-on-1-website-help',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const WorkSlugRoute = WorkSlugRouteImport.update({
            id: '/work/$slug',path: '/work/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,R1On1WebsiteHelpRoute: R1On1WebsiteHelpRoute,AiServicesRoute: AiServicesRoute,BrandingRoute: BrandingRoute,CarePlansRoute: CarePlansRoute,DesignSubscriptionRoute: DesignSubscriptionRoute,GetMockupRoute: GetMockupRoute,HomePageArchiveRoute: HomePageArchiveRoute,HomepageArchiveOriginalRoute: HomepageArchiveOriginalRoute,Homepage_testRoute: Homepage_testRoute,Homepage_test_2Route: Homepage_test_2Route,MaingearCaseStudyRoute: MaingearCaseStudyRoute,PaidAdsRoute: PaidAdsRoute,PrivacyRoute: PrivacyRoute,SeoRoute: SeoRoute,ServicesRoute: ServicesRoute,SiteSpeedRoute: SiteSpeedRoute,TermsRoute: TermsRoute,TestimonialArchiveRoute: TestimonialArchiveRoute,TheProblemRoute: TheProblemRoute,WebsitesRoute: WebsitesRoute,BlogSlugRoute: BlogSlugRoute,WorkSlugRoute: WorkSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)